<template>
  <Header_m></Header_m>
  <Team_index_m></Team_index_m>
  <Team_index_bar_m></Team_index_bar_m>
  <router-view/>
  <Footer_m></Footer_m>
</template>

<script>

import Team_index_m from "@/components/CN_mobile/team/Team_index_m";
import Team_index_bar_m from "@/components/CN_mobile/team/Team_index_bar_m";
import Footer_m from "@/components/CN_mobile/Footer_m";
import Header_m from "@/components/CN_mobile/Header_m";

export default {
  name: 'Team_m',
  components: {Footer_m, Team_index_bar_m, Team_index_m, Header_m},

}

</script>
